/**
 * blockActions — pure/client-only logic behind the block micro-menu's
 * "Copia" action (TASK-013 Phase A). No endpoint involved (see task's API
 * Contract: "Nessun endpoint per 'Copia' (client-side)") — this just derives
 * the text to copy and writes it to the clipboard.
 *
 * Kept separate from the BlockActionsMenu component (rather than inlined in
 * an onClick handler) so it's unit-testable without rendering React — this
 * app has no RTL/component-test infra (see TutorOverlay.tsx's
 * `nextFeedbackValue` doc comment for the established precedent).
 */

import { stripBlockPrefix } from '@arianna/reader-core'

/**
 * The exact text "Copia" puts on the clipboard: the block's markdown with
 * the redundant inline type marker stripped (`**Integrazione:**` etc — see
 * Success Criteria: "il contenuto del blocco (senza marcatori di prefisso
 * tipo [INTEGRAZIONE])"). A no-op for `paragraph` blocks, which never carry
 * the marker — safe to apply unconditionally to every block kind.
 */
export function blockCopyText(markdown: string): string {
  return stripBlockPrefix(markdown)
}

/**
 * Writes the block's de-prefixed text to the clipboard via the async
 * Clipboard API. Rejects if the API is unavailable (non-secure context / old
 * browser) or the user denies permission — the caller (BlockActionsMenu)
 * surfaces that as "no confirmation shown" rather than throwing into the UI.
 */
export async function copyBlockToClipboard(markdown: string): Promise<void> {
  await navigator.clipboard.writeText(blockCopyText(markdown))
}
